interface ShimmerProps {
  className?: string;
  variant?: 'card' | 'text' | 'circle' | 'rectangle' | 'line';
  lines?: number;
}

export default function Shimmer({ className = '', variant = 'card', lines = 1 }: ShimmerProps) {
  const base = 'shimmer-base';

  if (variant === 'card') {
    return (
      <div className={`${base} h-32 ${className}`} aria-hidden="true" />
    );
  }

  if (variant === 'text' || variant === 'line') {
    const widths = ['w-full', 'w-5/6', 'w-4/6', 'w-3/6'];
    return (
      <div className={`space-y-2 ${className}`} aria-hidden="true">
        {Array.from({ length: lines }).map((_, i) => (
          <div
            key={i}
            className={`${base} h-4 rounded-lg ${widths[i % widths.length]}`}
          />
        ))}
      </div>
    );
  }

  if (variant === 'circle') {
    return (
      <div className={`${base} rounded-full ${className}`} aria-hidden="true" />
    );
  }

  if (variant === 'rectangle') {
    return (
      <div className={`${base} rounded-xl ${className}`} aria-hidden="true" />
    );
  }

  return <div className={`${base} ${className}`} aria-hidden="true" />;
}
